<div class="topp">
  <span class="overskrift">{{ 'Dine grupper'|translate }}</span>
  @if (!viserOpprettGruppeSkjema()) {
    <button mat-button color="primary" (click)="opprettGruppe()">
      <mat-icon fontSet="ion-ios-plus-outline" class="mat-icon--ionic-ikon"/>
      {{ "Opprett ny gruppe" | translate }}
    </button>
  }
</div>
@if (viserOpprettGruppeSkjema()) {
  <gruppe-ny (vedOpprettet)="nyGruppeOpprettet($event)" (vedAvbryt)="vedAvbryt()" [visFulltSkjemaHeleTiden]="true"/>
}
<table mat-table matSort [dataSource]="ordinaereDataSource" >

  <ng-container matColumnDef="logo">
    <th mat-header-cell *matHeaderCellDef> </th>
    <td mat-cell *matCellDef="let gruppe" style="background: linear-gradient(to right, {{gruppe.farge}} 10px, transparent 10px);" class="logo">
      <gruppe-logo [gruppe]="gruppe" [stil]="'stor'"/>
    </td>
  </ng-container>
  <ng-container matColumnDef="organisasjonsnavn">
    <th *matHeaderCellDef mat-header-cell mat-sort-header > {{ 'Organisasjon'|translate }} </th>
    <td mat-cell *matCellDef="let gruppe"> {{ gruppe.organisasjonsnavn }} </td>
  </ng-container>
  <ng-container matColumnDef="tittel">
    <th mat-header-cell mat-sort-header *matHeaderCellDef > {{ 'Gruppe'|translate }} </th>
    <td mat-cell *matCellDef="let gruppe"> {{ gruppe.tittel }} </td>
  </ng-container>
  <ng-container matColumnDef="moetenavn">
    <th mat-header-cell mat-sort-header *matHeaderCellDef > {{ 'Møtenavn'|translate }} </th>
    <td mat-cell *matCellDef="let gruppe"> {{ gruppe.moetenavn }} </td>
  </ng-container>
  <ng-container matColumnDef="antMedlemmer">
    <th mat-header-cell mat-sort-header *matHeaderCellDef class="tallHeader" arrowPosition="before"> {{ 'Medlemmer'|translate }} </th>
    <td mat-cell *matCellDef="let gruppe" class="tall"> {{ antallAktiveMedlemmerIGruppe(gruppe) }} </td>
  </ng-container>
  <ng-container matColumnDef="antInviterte">
    <th mat-header-cell mat-sort-header *matHeaderCellDef class="tallHeader" arrowPosition="before"> {{ 'Inviterte'|translate }} </th>
    <td mat-cell *matCellDef="let gruppe" class="tall"> {{ antallInvitasjonerIGruppe(gruppe) }} </td>
  </ng-container>

  <ng-container matColumnDef="antmoeter">
    <th mat-header-cell mat-sort-header *matHeaderCellDef class="tallHeader" arrowPosition="before"> {{ 'Møter i år'|translate }} </th>
    <td mat-cell *matCellDef="let gruppe" class="tall"> {{ gruppe.antallMoeterInnevaerendeAar }} </td>
  </ng-container>
  <ng-container matColumnDef="innlogging">
    <th mat-header-cell mat-sort-header *matHeaderCellDef > {{ 'Sikkerhetsnivå innlogging'|translate }} </th>
    <td mat-cell *matCellDef="let gruppe"  >
      <div class="autentiseringsmetode-celle">
        @if(visVarselForAutentiseringsmetode(gruppe)) {
          <mat-icon class="advarsel" [matTooltip]="'Vi anbefaler at du setter opp 2-faktor innlogging på gruppa'" ]>warning</mat-icon>
        }
        <span [matTooltip]="autentiseringsmetoder(gruppe).join(', ')">{{ lavesteAutentiseringsmetodeTekst(gruppe) }}</span>
<!--        <span [matTooltip]="autentiseringsmetoder(gruppe).join(', ')">{{ autentiseringsmetoder(gruppe).join(', ') }}</span>-->
      </div>
    </td>
  </ng-container>
  <ng-container matColumnDef="vis">
    <th mat-header-cell *matHeaderCellDef >  </th>
    <td mat-cell *matCellDef="let gruppe" class="handlinger">
      <button mat-button type="button" (click)="gaaTilGruppe(gruppe.id)" data-testid="vis-detaljer">
        <mat-icon fontSet="ion-ios-arrow-thin-right" class="mat-icon--ionic-ikon"/>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="['logo','organisasjonsnavn', 'tittel','moetenavn','antMedlemmer','antmoeter','innlogging','vis']"></tr>
  <tr mat-row class="rad" *matRowDef="let gruppe; columns: ['logo','organisasjonsnavn', 'tittel','moetenavn','antMedlemmer','antmoeter','innlogging','vis'];" (click)="gaaTilGruppe(gruppe.id)"></tr>

</table>
